var _mask, _path, _path2, _rect, _rect2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHoverMenu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 142,
    height: 58,
    viewBox: "0 0 142 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-1-inside-1_8036_69286",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 0C4.47715 0 0 4.47715 0 10V38C0 43.5228 4.47715 48 10 48H64.8027L71.5 58L78.1973 48H132C137.523 48 142 43.5229 142 38V10C142 4.47715 137.523 0 132 0H10Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 0C4.47715 0 0 4.47715 0 10V38C0 43.5228 4.47715 48 10 48H64.8027L71.5 58L78.1973 48H132C137.523 48 142 43.5229 142 38V10C142 4.47715 137.523 0 132 0H10Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M64.8027 48L65.6336 47.4435L65.3366 47H64.8027V48ZM71.5 58L70.6691 58.5565L71.5 59.7971L72.3309 58.5565L71.5 58ZM78.1973 48V47H77.6634L77.3664 47.4435L78.1973 48ZM1 10C1 5.02944 5.02944 1 10 1V-1C3.92487 -1 -1 3.92487 -1 10H1ZM1 38V10H-1V38H1ZM10 47C5.02944 47 1 42.9706 1 38H-1C-1 44.0751 3.92487 49 10 49V47ZM64.8027 47H10V49H64.8027V47ZM72.3309 57.4435L65.6336 47.4435L63.9719 48.5565L70.6691 58.5565L72.3309 57.4435ZM77.3664 47.4435L70.6691 57.4435L72.3309 58.5565L79.0281 48.5565L77.3664 47.4435ZM132 47H78.1973V49H132V47ZM141 38C141 42.9706 136.971 47 132 47V49C138.075 49 143 44.0751 143 38H141ZM141 10V38H143V10H141ZM132 1C136.971 1 141 5.02944 141 10H143C143 3.92487 138.075 -1 132 -1V1ZM10 1H132V-1H10V1Z",
    fill: "#003E6B",
    mask: "url(#path-1-inside-1_8036_69286)"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 47,
    width: 1,
    height: 48,
    fill: "#003E6B"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 94,
    width: 1,
    height: 48,
    fill: "#003E6B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHoverMenu);
export default __webpack_public_path__ + "static/media/HoverMenu.eac1c10a13b8bf6d94c2f57f113a061e.svg";
export { ForwardRef as ReactComponent };